import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-md-8" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = { class: "p-field p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_multiselect = _resolveComponent("p-multiselect")!
  const _component_p_text = _resolveComponent("p-text")!
  const _component_p_dropdown = _resolveComponent("p-dropdown")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_card = _resolveComponent("p-card")!

  return (_openBlock(), _createBlock(_component_p_card, { class: "card" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", null, "Simulate Role", -1)),
          _createVNode(_component_p_multiselect, {
            filter: true,
            modelValue: _ctx.form.role,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.role) = $event)),
            options: _ctx.roles,
            optionValue: "code",
            optionLabel: "label",
            placeholder: "Select roles",
            display: "chip"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Username", -1)),
          _createVNode(_component_p_text, {
            modelValue: _ctx.form.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.username) = $event)),
            modelModifiers: { trim: true },
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Branch", -1)),
          _createVNode(_component_p_dropdown, {
            modelValue: _ctx.form.branch,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.branch) = $event)),
            options: _ctx.branches,
            optionLabel: "label",
            optionValue: "code",
            placeholder: "Select a branch",
            filter: true,
            filterPlaceholder: "Search by branch name."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_p_button, { onClick: _ctx.submitForm }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Apply ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}